// extracted by mini-css-extract-plugin
export default {"root":"login_root__BwAP0","main":"login_main__6sc+r","title":"login_title__G2uTT","subtitle":"login_subtitle__-ZLzb","submit":"login_submit__v0D8u"};